var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1098_9832",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1098_9832)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2082 0.5H5.79332C4.98799 0.5 4.33789 1.15301 4.33789 1.95689V19.0446C4.33789 19.8477 4.98799 20.5 5.79332 20.5H14.2082C15.012 20.5 15.6636 19.8477 15.6636 19.0446V1.95689C15.6636 1.15301 15.012 0.5 14.2082 0.5ZM7.92435 1.38477H12.0786C12.1835 1.38477 12.2688 1.54146 12.2688 1.73532C12.2688 1.92919 12.1835 2.08661 12.0786 2.08661H7.92435C7.81868 2.08661 7.73486 1.92919 7.73486 1.73532C7.73486 1.54146 7.81868 1.38477 7.92435 1.38477ZM10.0015 19.0621C9.48914 19.0621 9.07227 18.6452 9.07227 18.1321C9.07227 17.619 9.48915 17.2036 10.0015 17.2036C10.5124 17.2036 10.9293 17.619 10.9293 18.1321C10.9293 18.6452 10.5124 19.0621 10.0015 19.0621ZM14.5733 15.8779H5.42896V2.95825H14.5733V15.8779H14.5733Z",
    fill: "#10B48C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.cff9e7c3c9c7d3758bc4ed06e8037e96.svg";
export { ForwardRef as ReactComponent };